import React, { useState } from 'react';
import { Typography, Card, Row, Col, Divider, Space, Button, Modal } from 'antd';
import { RocketOutlined, TeamOutlined, EnvironmentOutlined, FileTextOutlined, ArrowLeftOutlined, BulbOutlined, HomeOutlined, SafetyOutlined, CheckCircleOutlined } from '@ant-design/icons';
import PageTemplate from './PageTemplate';
import { useNavigate } from 'react-router-dom';
const { Title, Paragraph } = Typography;

function AboutPage() {
  const navigate = useNavigate();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <PageTemplate>
      {/* Hero section */}
      <div className="flex justify-start mb-4">
        <Button type="link" onClick={() => navigate('/')} className="text-blue-600">
          <ArrowLeftOutlined /> Înapoi la principală
        </Button>
      </div>
      <div className="bg-gradient-to-r from-blue-600 to-indigo-800 p-10 min-h-[300px] max-w-7xl mx-auto rounded-lg shadow-lg text-center flex flex-col justify-center items-center">
        <h1 className="text-white mb-6 text-4xl">Despre DANCO - Soluții Complete pentru Grădinițe, Școli și Primării</h1>
        <p className="text-white text-lg mb-8">
          Cu o experiență îndelungată pe piața din Republica Moldova, DANCO oferă produse de calitate superioară 
          pentru instituții educaționale și administrație publică, transformând spațiile în medii funcționale și sigure.
        </p>
      </div>

      {/* Main description */}
      <div className="bg-white mt-10 p-10 max-w-7xl mx-auto rounded-lg shadow-md">
        <Title level={2} className="text-center mb-8">Povestea Noastră</Title>
        <Paragraph className="text-lg mb-8">
          DANCO s-a născut din dorința de a contribui la dezvoltarea infrastructurii educaționale și publice 
          din Republica Moldova. Pe parcursul anilor, ne-am impus ca un furnizor de încredere, oferind soluții 
          complete și personalizate pentru grădinițe, școli și instituții publice.
        </Paragraph>
        <Paragraph className="text-lg mb-8">
          Misiunea noastră este să creăm spații educaționale și publice moderne, sigure și funcționale, 
          care să inspire și să susțină dezvoltarea comunităților locale. Fiecare produs pe care îl oferim 
          este gândit cu atenție la detalii, durabilitate și siguranță.
        </Paragraph>

        <Title level={3} className="mb-6">Gama Noastră de Produse</Title>
        
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300 mb-6"
              cover={<div className="bg-green-50 p-6 flex justify-center"><RocketOutlined style={{ fontSize: 48, color: '#1890ff' }} /></div>}
            >
              <Title level={4}>Terenuri de Joacă</Title>
              <Paragraph>
                Proiectăm și instalăm terenuri de joacă moderne, sigure și durabile pentru grădinițe și școli. 
                Toate echipamentele respectă standardele europene de siguranță și sunt adaptate pentru diferite 
                grupe de vârstă.
              </Paragraph>
              <Paragraph>
                <strong>Caracteristici:</strong> Materiale rezistente la intemperii, design ergonomic, 
                certificare de siguranță și instalare profesională.
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300 mb-6"
              cover={<div className="bg-blue-50 p-6 flex justify-center"><EnvironmentOutlined style={{ fontSize: 48, color: '#52c41a' }} /></div>}
            >
              <Title level={4}>Mobilier Urban</Title>
              <Paragraph>
                Oferim o gamă completă de mobilier urban pentru spații publice: bănci, coșuri de gunoi, 
                jardiniere și alte elemente decorative care îmbunătățesc aspectul și funcționalitatea 
                spațiilor comunitare.
              </Paragraph>
              <Paragraph>
                <strong>Avantaje:</strong> Rezistență la coroziune, design modern, materiale durabile 
                și întreținere minimă necesară.
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-yellow-50 p-6 flex justify-center"><BulbOutlined style={{ fontSize: 48, color: '#faad14' }} /></div>}
            >
              <Title level={4}>Tehnică pentru Oficiu</Title>
              <Paragraph>
                Furnizăm echipamente moderne și fiabile pentru birouri administrative și săli de clasă: 
                imprimante, calculatoare, table interactive și alte soluții tehnologice necesare pentru 
                activitatea zilnică.
              </Paragraph>
              <Paragraph>
                <strong>Servicii incluse:</strong> Consultanță tehnică, instalare, instruire personal 
                și suport tehnic continuu.
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-purple-50 p-6 flex justify-center"><TeamOutlined style={{ fontSize: 48, color: '#722ed1' }} /></div>}
            >
              <Title level={4}>Mobilier din Inox</Title>
              <Paragraph>
                Specializați în soluții din inox de înaltă calitate pentru cantine școlare, bucătării 
                profesionale și alte spații care necesită standarde ridicate de igienă și durabilitate.
              </Paragraph>
              <Paragraph>
                <strong>Caracteristici:</strong> Rezistență la coroziune, ușor de curățat, conform 
                standardelor sanitare și garanție extinsă.
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-orange-50 p-6 flex justify-center"><HomeOutlined style={{ fontSize: 48, color: '#fa541c' }} /></div>}
            >
              <Title level={4}>Mobilier pentru Școli</Title>
              <Paragraph>
                Gamă completă de mobilier școlar: bănci, scaune, dulapuri, mese și alte piese ergonomice 
                și durabile, special adaptate pentru mediul educațional și confortul elevilor.
              </Paragraph>
              <Paragraph>
                <strong>Beneficii:</strong> Design ergonomic, materiale sigure, disponibile în diverse 
                dimensiuni și culori pentru toate vârstele.
              </Paragraph>
            </Card>
          </Col>
          
          <Col xs={24} lg={12}>
            <Card 
              className="h-full hover:shadow-lg transition-all duration-300"
              cover={<div className="bg-red-50 p-6 flex justify-center"><SafetyOutlined style={{ fontSize: 48, color: '#f5222d' }} /></div>}
            >
              <Title level={4}>Soluții de Siguranță</Title>
              <Paragraph>
                Oferim echipamente de siguranță pentru instituții: sisteme de supraveghere, 
                detectoare de fum, sisteme de alarmare și alte soluții pentru protecția copiilor și personalului.
              </Paragraph>
              <Paragraph>
                <strong>Avantaje:</strong> Tehnologie modernă, monitorizare 24/7, instalare profesională 
                și mentenanță inclusă.
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>

      <Divider className="my-10" />
      
      {/* Values section */}
      <div className="bg-gray-50 mt-10 p-10 max-w-7xl mx-auto rounded-lg shadow-md">
        <Title level={2} className="text-center mb-8">Valorile Noastre</Title>
        <Row gutter={[32, 32]}>
          <Col xs={24} md={8}>
            <div className="text-center">
              <CheckCircleOutlined style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }} />
              <Title level={4}>Calitate</Title>
              <Paragraph>
                Toate produsele noastre sunt realizate din materiale de calitate superioară 
                și respectă standardele europene de siguranță și durabilitate.
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div className="text-center">
              <TeamOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
              <Title level={4}>Parteneriat</Title>
              <Paragraph>
                Construim relații pe termen lung cu clienții noștri, oferind suport continuu 
                și soluții personalizate pentru fiecare instituție.
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div className="text-center">
              <BulbOutlined style={{ fontSize: 48, color: '#faad14', marginBottom: 16 }} />
              <Title level={4}>Inovație</Title>
              <Paragraph>
                Investim continuu în cercetare și dezvoltare pentru a oferi soluții moderne 
                și eficiente, adaptate nevoilor în continuă schimbare.
              </Paragraph>
            </div>
          </Col>
        </Row>
      </div>

      {/* Contact section */}
      <div className="bg-blue-50 mt-10 p-10 max-w-7xl mx-auto rounded-lg shadow-md">
        <Row gutter={[48, 24]} align="middle">
          <Col xs={24} lg={12}>
            <Title level={2}>De Ce Să Alegeți DANCO?</Title>
            <Paragraph className="text-lg">
              Cu o experiență vastă în domeniu și o echipă de specialiști dedicați, DANCO oferă 
              mai mult decât simple produse - oferim soluții complete și suport pe termen lung.
            </Paragraph>
            <Paragraph className="text-lg">
              Suntem mândri să contribuim la dezvoltarea infrastructurii educaționale din Republica Moldova 
              și să facem parte din povestea de succes a fiecărei instituții pe care o deservim.
            </Paragraph>
          </Col>
          <Col xs={24} lg={12}>
            <div className="bg-white p-8 rounded-lg">
              <Title level={3} className="text-center mb-6">Contactați-ne pentru o Ofertă</Title>
              <Paragraph className="text-center mb-6">
                Echipa noastră de specialiști este gata să vă ajute să găsiți soluțiile perfecte 
                pentru instituția dumneavoastră.
              </Paragraph>
              <div className="text-center space-y-4">
                <p><strong>Email:</strong> info@danco.md</p>
                <p><strong>Telefon:</strong> +373 78 888 001</p>
                <p><strong>Adresa:</strong> Chișinău, str. Columna 102</p>
                <Button type="primary" size="large" onClick={() => setIsContactModalOpen(true)} className="mt-4">
                  Solicită o Ofertă
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Contact Modal */}
      <Modal
        title={null}
        open={isContactModalOpen}
        onCancel={() => setIsContactModalOpen(false)}
        footer={null}
        width={500}
        className="contact-modal"
        centered
        bodyStyle={{ padding: "0" }}
      >
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 p-8 text-center">
          <div className="flex justify-center mb-6">
            <img 
              src="/Logo_Danco.png" 
              alt="DANCO Logo" 
              className="h-16 w-auto"
            />
          </div>
          <Title level={3} className="mb-2 text-gray-800">Contactați-ne</Title>
          <Paragraph className="text-gray-600 mb-8">
            Suntem aici pentru a vă ajuta cu toate întrebările și solicitările dumneavoastră
          </Paragraph>
          
          <div className="space-y-4">
            {/* Phone Contact */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-green-100 p-3 rounded-full">
                    <span className="text-2xl">📞</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Telefon</h4>
                    <p className="text-gray-600">+373 78 888 001</p>
                  </div>
                </div>
                <Button 
                  type="primary" 
                  className="bg-green-500 hover:bg-green-600 border-green-500"
                  onClick={() => window.open('tel:+37378888001')}
                >
                  Sună Acum
                </Button>
              </div>
            </div>

            {/* Email Contact */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <span className="text-2xl">📧</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Email</h4>
                    <p className="text-gray-600">info@danco.md</p>
                  </div>
                </div>
                <Button 
                  type="primary" 
                  onClick={() => window.open('mailto:info@danco.md')}
                >
                  Trimite Email
                </Button>
              </div>
            </div>

            {/* Address */}
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="bg-purple-100 p-3 rounded-full">
                    <span className="text-2xl">📍</span>
                  </div>
                  <div className="text-left">
                    <h4 className="font-semibold text-gray-800 mb-1">Adresa</h4>
                    <p className="text-gray-600">Chișinău, str. Columna 102</p>
                  </div>
                </div>
                <Button 
                  type="default"
                  onClick={() => window.open('https://maps.google.com/?q=Chișinău, str. Columna 102', '_blank')}
                >
                  Vezi pe Hartă
                </Button>
              </div>
            </div>
          </div>

          {/* Program de lucru */}
          <div className="mt-8 p-4 bg-white/70 rounded-lg border border-white/50">
            <h4 className="font-semibold text-gray-800 mb-2">Program de lucru</h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>Luni - Vineri: 09:00 - 18:00</p>
              <p>Sâmbătă: 09:00 - 14:00</p>
              <p>Duminică: Închis</p>
            </div>
          </div>
        </div>
      </Modal>
    </PageTemplate>
  );
}

export default AboutPage;
